import { Navigate } from 'react-router-dom';

export const RoutesOwnerSpecialist = ({ children }: any) => {
    const userRol = JSON.parse(localStorage.getItem('Roles') as string);
    const owner = userRol
        ? userRol.filter((s: any) => s.Name === 'Owner' || s.Name === 'Specialist')
        : null;
    const user = JSON.parse(localStorage.getItem('currentUsr')!);

    return user && owner.length > 0 ? children : <Navigate to='/home' />;
};
